import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {IRole, Role} from '../models/role.model';

const RoleNames = ['ADMIN',
  'DEV',
  'MODERATOR',
  'SELLER',
  'CUSTOMER'];

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  getRoleName(): any {
    return RoleNames;
  }
  getRole(): Observable<any> {
  return this.http.get<any>(`${environment.url}/role`);
  }
  getRoleBySession(kapo_session_id): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + kapo_session_id);
  return this.http.get<any>(`${environment.url}/role`, {headers: headers});
  }
  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/role` + (size ? '?page=' + page + '&size=' + size : ''));
  }
  getRoleBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/role` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }
  saveRole(Role: IRole) {
    return this.http.post<any>(`${environment.url}/role`, Role);
  }
  getidRole(idA: number) {
    return this.http.get<any>(`${environment.url}/role/` + idA);
  }
  getidRoleName(name: string) {
    return this.http.get<any>(`${environment.url}/role/byName/` + name);
  }
  updateRole(Role: IRole) {
    return this.http.put<any>(`${environment.url}/role/` + Role.id, Role);
  }
  deleteRole(idA: number) {
    return this.http.delete(`${environment.url}/role/` + idA);
  }
}
